import axios from 'axios';

const GOOGLE_FONTS_API = `${process.env.VUE_APP_API_URL}/v3/google-fonts`;

export const getGoogleFonts = async (parameters) => {
	const { data } = await axios.get(GOOGLE_FONTS_API, { params: parameters });

	return data;
};
